import Phaser from 'phaser'
import $ from 'jquery'
import {
    CST
} from '../../../CST'

var turn = 0;

var human;
var comp;
var current;
var firstTurn;

const winners = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 1, 2],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6]
];

var boardArr = [0, 1, 2, 3, 4, 5, 6, 7, 8];
var humanArr = [];
var compArr = [];

var gameWon = false;

export default class TicTacToe extends Phaser.Scene {

    constructor() {
        super(CST.SCENES.TICTACTOE);
    }

    preload() {
        this.bg;
        this.blankSquare;
        this.self = this;
    }

    create() {
        this.bg = this.add.image(0, 0, "black-bg").setScale(8);
        
        let blankSquareSize = 200; //200
        let halfBlankSquareSize = 100; //100    
        let nKey = 0; // 0 - 8
    
            human = p1;
            comp = p2;
            current = human;
            firstTurn = 'human';

        var p1 = [1, 'O', 0]; // [player,sign,wins]
        var p2 = [2, 'X', 0];

        for (let row = 0; row < 3; row++) {
            let y = halfBlankSquareSize + (blankSquareSize * row) + (row * 10);
                                 
            // This inner loop gets executed before the outer loop
            // so our sprites will be created by column first, then by row
            for (let col = 0; col < 3; col++) {
                let x = halfBlankSquareSize + (blankSquareSize * col) + (col * 10);
                console.log(x, y);
                let sprite = this.add.sprite(x + 450, y + 80, 'blank-square');
                sprite.myKey = nKey++;
                sprite.setInteractive({useHandCursor: true}).on("pointerdown", () => {
                    this.add.sprite(x + 450, y + 80, 'ox-spritesheet').setFrame(0);
                    sprite.disableInteractive();
                    boardArr.splice(sprite.myKey, 1); 
                    humanArr.push(sprite.myKey);
                    console.log(boardArr, humanArr);
                    checkEnd(this, humanArr, winners);   
                    compTurn(this);
                    /*setTimeout(() => {
                        let compChoice = Math.round(Math.random() * boardArr.length);
                        sprite.myKey = compChoice;
                        this.add.sprite(sprite.x, sprite.y, 'ox-spritesheet').setFrame(1);
                        console.log(x, y, sprite.x, sprite.y);
                        sprite.disableInteractive();
                        boardArr.splice(sprite.myKey, 1);
                        compArr.push(sprite.myKey);
                        console.log(boardArr, compArr);
                        checkEnd(this, compArr, winners);
                    }, 1500);*/
                });
            }
        }
    }
}

//FUNCTIONS TO BE CALLED FOR TURNS

//pickEmpty, used for computers turn to pick a random empty square.
function pickEmpty() {
    var emptyArr = [];
    for (var i = 0; i < boardArr.length; i++) {
        if (boardArr[i] === '#') {
            emptyArr.push(i);
        }
    }
    var x = Math.round(Math.random() * emptyArr.length);
    var choice = emptyArr[x];
    if (choice === undefined) {
        choice = emptyArr[x - 1];
        /*this.add.sprite(x + 450, y + 80, 'ox-spritesheet').setFrame(1);
        sprite.disableInteractive();*/
    }
    return choice;
};

//COMPUTERS TURN
function compTur() {
    let current = comp;
    var tile = pickEmpty();
    $('#' + tile).html(comp[1]);
    boardArr[tile] = comp[1];
    checkWin(current);
    if (gameWon === 1 || gameWon === 2) {
        alert("Computer wins!");
        winReset(comp);
    } else {
        turn++;
        checkDraw();
        if (turn === 0 && human[0] === 2) {
            compTurn();
        }
    }
};

function compTurn(self){
    var choice = Math.round(Math.random() * boardArr.length);
    boardArr.splice(choice, 1); 
    compArr.push(choice);
    console.log(choice);
    console.log(boardArr, compArr);
    let sprite = self.add.sprite(x + 450, y + 80, 'ox-spritesheet').setFrame(1);
    sprite.disableInteractive();
    checkEnd(self, compArr, winners);
}

//HUMANS TURN
function humanTur(tile) {
    let current = human;
    $('#' + tile).html(human[1]);
    boardArr[tile] = human[1];
    checkWin(current);
    if (gameWon === 1 || gameWon === 2) {
        alert("Nice one, you win!");
        var reset = setTimeout(winReset(human), 1000);
    } else {
        turn++;
        checkDraw();
        if (turn !== 0) {
            var compGo = setTimeout(compTurn, 800);
        } else if (turn === 0 && human[0] === 2) {
            compTurn();
        }
    }
}

//Function to check for a win
function checkEnd (self, current, winners){
    for (var x = 0; x < winners.length; x++) {
        var count = 0;
        for (var j = 0; j < winners[x].length; j++) {
            if (current.indexOf(winners[x][j]) != -1) {
                count++;
            }
            if (count == 3) {
                self.scene.resume(CST.SCENES.STORY_SELECT, 5);
                self.scene.stop();
            }
        }
    }
}

/**************Upon win, updates scores and resets board for new game********/
function winReset(winner) {
    winner[2]++;
    $('#scores').html('P1: ' + p1[2] + ' <br>P2: ' + p2[2]);
    turn = 0;
    $('td').html('');
    boardArr = ["#", "#", "#", "#", "#", "#", "#", "#", "#"];
    if (human === p1) {
        current = human;
    } else {
        let current = comp;
        var tile = pickEmpty();
        $('#' + tile).html(comp[1]);
        boardArr[tile] = comp[1];
        turn++;

    }
    gameWon = false;
}

/*******************CHECKS FOR DRAW*********************/
function checkDraw() {
    if (turn > 8) {
        alert("It's a Draw!");
        $('td').html('');
        boardArr = ["#", "#", "#", "#", "#", "#", "#", "#", "#"];
        if (human === p1) {
            current = human;
        } else {
            current = comp;
        }
        turn = 0;
    }
}